import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import * as Mui from "@mui/material";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { useFetch } from "services/hooks/useFetch";
import { themes, scrollTop } from "services/constants";
import { useSelector } from "react-redux";
import { showToast } from "services/utils/Status";
import { useForm } from "react-hook-form";
import { tableRowSize } from "services/constants";
import { Typography, Box, Paper, Drawer } from "@mui/material";
import { customGetAPI } from "services/utils/CustomAPI";
import { customAPI } from "services/utils/CustomAPI";
import { Loader } from "components/Loader";
import { ShiftAssignmentHeader } from "pages/Administration/AdministrationHeaders";
import { CreateShiftRota } from "./CreateShiftRota";
import { ViewShiftRotaPanel } from "./ViewShiftRotaPanel";
import { useShiftRota } from "./ShiftRotaContext";
import { CustomFilter } from "components/CustomComponents/CustomFilter";
import { useFilter } from "pages/FilterContext";

import { CustomButton } from "components/CustomComponents/CustomButton";
import { TableEmptyState } from "components/CustomComponents/EmptyState";
import moment from "moment";
import { useSaveView } from "components/CustomComponents/useSaveView";

const keys = ["name", "shift_duration", "working_hours", "break_duration"];
const getAutoShiftAssignBasedOnValue = (value) => {
  if (value === "Shift Start Time") return "shift_start_time";
  if (value === "Shift Full Time") return "shift_full_time";
  return value || "";
};

export const ShiftRota = ({ showFullPage, setShowFullPage, subModuleId }) => {
  const { domain, userScreenAccess, topbarCompanyName, userDetails } =
    useSelector((state) => state.tokenReducer);
  const { setValue, watch, getValues } = useForm({
    mode: "onBlur",
  });
  const { hanldeLoading } = useFilter();
  const [opendSidebar, setOpenSidebar] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [shiftRotaData, setShiftRotaData] = useState();
  const [isCreatePanelOpen, setIsCreatePanelOpen] = useState(false);
  const [isViewPanelOpen, setIsViewPanelOpen] = useState(false);
  const [openSidePeak, setOpenSidePeak] = useState(false);
  const containerRef = useRef(null);
  const [handleLoader, setHandleLoader] = useState(true);
  const {
    setActiveStep,
    setRepresentationWeekdays,
    setRepresentationShifts,
    setShiftRotationDetails,
    setRepresentationNonRandom,
    sftAssignId,
    setSftAssignId,
    editSftRotaData,
    setNumberOfSft,
    setEditSftRotaData,
    getShiftRotaData,
    setGetShiftRotaData,
    formData,
    setFormData,
    WeekDaysData,
    setWeekDaysData,
    setAllGroupDetails,
    shiftCycleDetails,
    setShiftCycleDetails,
    setDataUpdated,
  } = useShiftRota();

  let check_access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Shift",
    "Shift Roster",
  );

  const {
    result: shiftAssignData,
    setLoad: reCallApi,
    loading,
  } = useFetch(
    `${domain}administration/shiftroster/shiftrota/shift-assignments/`,
  );
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  const handleCreateShiftRota = () => {
    setOpenSidebar(true);
    setIsCreatePanelOpen(true);
  };

  const handleViewShift = () => {
    setOpenSidebar(true);
    setIsViewPanelOpen(true);
  };

  const handleCreateClosePanel = () => {
    setIsCreatePanelOpen(false);
    setOpenSidebar(false);
    setShowFullPage(false);
    setNumberOfSft(false);
    setActiveStep(0);
    setFormData({
      config: {},
      schedule: {},
      preview: {},
    });
  };

  const handleViewClosePanel = () => {
    setIsViewPanelOpen(false);
    setOpenSidebar(false);
    setRepresentationWeekdays([]);
    setRepresentationShifts([]);
    setShiftRotationDetails([]);
  };

  useEffect(() => {
    const getShiftRepresentation = async () => {
      if (formData?.schedule?.rotation_based_on === "Weekdays") {
        setValue("handle_loading", true);
        const res = await customAPI(
          `${domain}administration/shiftroster/shiftrota/weekly/shift-assignment/representaion/`,
          "POST",
          {
            name: formData?.config?.shift_assignment_name.trim(),
            rotation_based_on: formData?.schedule?.rotation_based_on,
            shift_groups:
              formData?.config?.shiftGroup?.map((item) => item.id) || [],
            shifts: formData?.config?.shift?.map((item) => item.id) || [],
            rotation_frequency:
              formData?.schedule?.rotation_frequency === "Week"
                ? "Weekly"
                : "Monthly",
            rotation_day:
              formData?.schedule?.rotation_frequency === "Month"
                ? parseInt(formData?.schedule?.rotation_month_day)
                : formData?.schedule?.rotation_day_week,
            no_of_repetition: parseInt(
              formData?.schedule?.duration_for_one_cycle,
            ),
            start_date: formData?.config?.effective_from,
            first_rotation_date: formData?.schedule?.first_rotation_date
              .split("/")
              .reverse()
              .join("-"),
            cycles: WeekDaysData,
            auto_shift_assign: formData?.schedule?.auto_sft_assign === "Yes",
            auto_shift_assign_based_on:
              formData?.schedule?.auto_sft_assign === "Yes"
                ? getAutoShiftAssignBasedOnValue(
                    formData?.schedule?.auto_shift_assign_based_on,
                  ) || "shift_start_time"
                : null,
            next_shift_start_buffer:
              formData?.schedule?.auto_sft_assign === "Yes" &&
              getAutoShiftAssignBasedOnValue(
                formData?.schedule?.auto_shift_assign_based_on,
              ) === "shift_full_time"
                ? parseInt(formData?.schedule?.next_shift_start_buffer) || 0
                : null,
            number_of_shifts: formData?.config?.no_of_shifts,
            shift_type: formData?.config?.is_random,
            shift_assignment_id: editSftRotaData ? editSftRotaData?.id : null,
          },
        );
        if (res.ok) {
          setRepresentationWeekdays(res?.responseDetails);
          setValue("handle_loading", false);
        }
      } else {
        setValue("handle_loading", true);
        const res = await customAPI(
          `${domain}administration/shiftroster/shiftrota/shift-assignment-representation-get/`,
          "POST",
          {
            name: formData?.config?.shift_assignment_name.trim(),
            rotation_based_on: formData?.schedule?.rotation_based_on,
            shift_groups:
              formData?.config?.shiftGroup?.map((item) => item.id) || [],
            shifts: formData?.config?.shift?.map((item) => item.id) || [],
            rotation_frequency:
              formData?.schedule?.rotation_frequency === "Week"
                ? "Weekly"
                : "Monthly",
            rotation_day:
              formData?.schedule?.rotation_frequency === "Month"
                ? parseInt(formData?.schedule?.rotation_month_day)
                : formData?.schedule?.rotation_day_week,
            no_of_repetition: parseInt(
              formData?.schedule?.duration_for_one_cycle,
            ),
            start_date: formData?.config?.effective_from,
            first_rotation_date: formData?.schedule?.first_rotation_date
              .split("/")
              .reverse()
              .join("-"),
            cycles: shiftCycleDetails,
            auto_shift_assign: formData?.schedule?.auto_sft_assign === "Yes",
            auto_shift_assign_based_on:
              formData?.schedule?.auto_sft_assign === "Yes"
                ? getAutoShiftAssignBasedOnValue(
                    formData?.schedule?.auto_shift_assign_based_on,
                  ) || "shift_start_time"
                : null,
            next_shift_start_buffer:
              formData?.schedule?.auto_sft_assign === "Yes" &&
              getAutoShiftAssignBasedOnValue(
                formData?.schedule?.auto_shift_assign_based_on,
              ) === "shift_full_time"
                ? parseInt(formData?.schedule?.next_shift_start_buffer) || 0
                : null,
            number_of_shifts: formData?.config?.no_of_shifts,
            shift_type: formData?.config?.is_random,
          },
        );
        if (res.ok) {
          setRepresentationShifts(res?.responseDetails?.cycles);
          setShiftRotationDetails(res?.responseDetails);
          setValue("handle_loading", false);
        }
      }
    };
    if (
      formData?.schedule?.callRepresentationApi &&
      parseInt(formData?.config?.no_of_shifts) > 1
    ) {
      getShiftRepresentation();
      setFormData((prev) => ({
        ...prev,
        schedule: { ...prev.schedule, callRepresentationApi: false },
      }));
    }
  }, [
    WeekDaysData,
    domain,
    editSftRotaData,
    editSftRotaData?.id,
    formData?.config?.effective_from,
    formData?.config?.is_random,
    formData?.config?.no_of_shifts,
    formData?.config?.shift,
    formData?.config?.shiftGroup,
    formData?.config?.shift_assignment_name,
    formData?.schedule?.auto_sft_assign,
    formData?.schedule?.auto_shift_assign_based_on,
    formData?.schedule?.callRepresentationApi,
    formData?.schedule?.duration_for_one_cycle,
    formData?.schedule.effective_from,
    formData?.schedule?.first_rotation_date,
    formData?.schedule?.next_shift_start_buffer,
    formData?.schedule?.rotation_based_on,
    formData?.schedule?.rotation_day_week,
    formData?.schedule?.rotation_frequency,
    formData?.schedule?.rotation_month_day,
    getValues,
    setFormData,
    setRepresentationShifts,
    setRepresentationWeekdays,
    setShiftRotationDetails,
    setValue,
    shiftCycleDetails,
    watch,
  ]);

  useEffect(() => {
    const getRepresentation = async () => {
      setValue("handle_loading", true);
      const res = await customAPI(
        `${domain}administration/shiftroster/shiftrota/random/shift-assignment/representaion/`,
        "POST",
        {
          name: formData?.config?.shift_assignment_name.trim(),
          shift_groups:
            formData?.config?.shiftGroup?.map((item) => item.id) || [],
          shifts: formData?.config?.shift?.map((item) => item.id) || [],
          shift_type: formData?.config?.is_random,
          start_date: formData?.config?.effective_from,
          number_of_shifts: formData?.config?.no_of_shifts,
          cycles: [],
        },
      );
      if (res.ok) {
        setRepresentationNonRandom(res?.responseDetails);
        setValue("handle_loading", false);
      }
    };
    if (
      formData?.config?.data_updated &&
      parseInt(formData?.config?.no_of_shifts) === 1
    ) {
      getRepresentation();
      setFormData((prev) => ({
        ...prev,
        config: { ...prev.config, data_updated: false },
      }));
    }
  }, [
    domain,
    formData?.config?.data_updated,
    formData?.config?.effective_from,
    formData?.config?.is_random,
    formData?.config?.no_of_shifts,
    formData?.config.sft_assignment_id,
    formData?.config?.shift,
    formData?.config?.shiftGroup,
    formData?.config?.shift_assignment_name,
    formData.schedule.callRepresentationApi,
    formData.schedule.rotation_based_on,
    formData.schedule.sft_assignment_id,
    getValues,
    isViewPanelOpen,
    setFormData,
    setRepresentationNonRandom,
    setValue,
    watch,
  ]);

  useEffect(() => {
    const getSftAssignData = async () => {
      let url = `${domain}administration/shiftroster/shiftrota/shift-assignments/${sftAssignId}/`;

      if (url) {
        const res = await customGetAPI(url);
        if (res.ok) {
          setEditSftRotaData(res?.responseDetails);
          setDataUpdated(true);
        }
      }
    };
    if (getShiftRotaData) {
      getSftAssignData();
      setGetShiftRotaData(false);
    }
  }, [
    domain,
    getShiftRotaData,
    setDataUpdated,
    setEditSftRotaData,
    setGetShiftRotaData,
    sftAssignId,
  ]);

  useEffect(() => {
    if (
      editSftRotaData &&
      editSftRotaData?.shifts &&
      editSftRotaData?.shift_groups
    ) {
      setFormData({
        config: {
          shift_assignment_name: editSftRotaData?.name || "",
          effective_from:
            editSftRotaData?.start_date?.split("-").reverse().join("-") || "",
          no_of_shifts: editSftRotaData?.number_of_shifts?.toString() || "",
          shift:
            editSftRotaData?.shifts?.map((shift) => ({
              id: shift.shift_id,
              name: shift.shift_name,
              start_time: shift.start_time,
              end_time: shift.end_time,
              color_code: shift.color_code,
            })) || [],
          shiftGroup:
            editSftRotaData?.shift_groups?.map((shift_group) => ({
              id: shift_group.shift_group_id,
              name: shift_group.shift_group_name,
            })) || [],
          is_random: editSftRotaData?.shift_type,
          sft_assignment_id: editSftRotaData?.id,
          recallApi: true,
        },
        schedule: {
          rotation_based_on: editSftRotaData?.rotation_based_on || "",
          rotation_frequency:
            editSftRotaData?.rotation_frequency === "Monthly"
              ? "Month"
              : "Week" || "",
          rotation_day_week:
            editSftRotaData?.rotation_frequency === "Monthly"
              ? null
              : editSftRotaData?.rotation_day,
          rotation_month_day:
            editSftRotaData?.rotation_frequency === "Monthly"
              ? editSftRotaData?.rotation_day
              : null,
          effective_from: editSftRotaData?.start_date
            .split("-")
            .reverse()
            .join("-"),
          duration_for_one_cycle: editSftRotaData?.no_of_repetition || "",
          first_rotation_date: editSftRotaData?.first_rotation_date
            ? editSftRotaData?.first_rotation_date.split("-").join("/")
            : "" || "",
          auto_sft_assign: editSftRotaData?.auto_shift_assign
            ? "Yes"
            : "No" || "",
          start_buffer:
            editSftRotaData?.start_buffer ??
            editSftRotaData?.auto_shift_before_start ??
            "60",
          end_buffer:
            editSftRotaData?.end_buffer ??
            editSftRotaData?.auto_shift_after_start ??
            "90",
          is_shift_full_time:
            editSftRotaData?.is_shift_full_time ??
            (editSftRotaData?.auto_shift_assign_based_on === "shift_full_time"),
        },
        preview: editSftRotaData?.preview || {},
      });
      let overAllData = [];
      let shiftData =
        editSftRotaData?.shifts?.map((shift) => ({
          id: shift?.shift_id,
          name: shift?.shift_name,
        })) || [];

      if (editSftRotaData?.rotation_based_on === "Shift") {
        overAllData = editSftRotaData?.cycles?.map((cycle) => {
          return {
            ...cycle,
            assignments: cycle?.assignments?.map((assign) => ({
              ...assign,
              shiftDetails: shiftData,
            })),
          };
        });
      } else {
        overAllData = editSftRotaData?.cycles?.flat().map((group) => ({
          ...group,
          shiftDetails: shiftData,
        }));
      }
      setWeekDaysData(
        editSftRotaData?.rotation_based_on !== "Shift" ? overAllData : [],
      );
      setShiftCycleDetails(
        editSftRotaData?.rotation_based_on === "Shift" ? overAllData : [],
      );
      setAllGroupDetails(
        editSftRotaData?.shift_groups?.map((g) => ({
          name: g.shift_group_name,
          id: g.shift_group_id,
        })) || [],
      );
      setNumberOfSft(editSftRotaData?.number_of_shifts?.toString() === "1");
    }
  }, [
    editSftRotaData,
    setAllGroupDetails,
    setFormData,
    setNumberOfSft,
    setShiftCycleDetails,
    setWeekDaysData,
  ]);

  const renderComponent = () => {
    return isCreatePanelOpen ? (
      <CreateShiftRota
        onClose={handleCreateClosePanel}
        reCallApi={reCallApi}
        showFullPage={showFullPage}
        setShowFullPage={setShowFullPage}
        setOpenSidebar={setOpenSidebar}
        loader={watch("handle_loading")}
        setHandleLoader={setHandleLoader}
      />
    ) : isViewPanelOpen ? (
      <ViewShiftRotaPanel
        onClose={handleViewClosePanel}
        reCallApi={reCallApi}
        setIsViewPanelOpen={setIsViewPanelOpen}
        showFullPage={showFullPage}
        setShowFullPage={setShowFullPage}
        opendSidebar={opendSidebar}
        setOpenSidebar={setOpenSidebar}
        setHandleLoader={setHandleLoader}
        loader={watch("handle_loading")}
        openSidePeak={openSidePeak}
        setOpenSidePeak={setOpenSidePeak}
        screenAccess={check_access}
      />
    ) : null;
  };

  const handleFilteredDataChange = useCallback(
    (filteredData) => {
      setShiftRotaData(filteredData);
      if (page * rowsPerPage >= filteredData.length) setPage(0);
    },
    [page, rowsPerPage],
  );

  const reportMetadata = useMemo(
    () => ({
      "Company Name": topbarCompanyName || "N/A",
      "Report Generated On": moment().format("DD/MM/YYYY HH:mm:ss"),
    }),
    [topbarCompanyName],
  );

  const handleSavedViewChange = useCallback(() => {
    setPage(0);
  }, []);

  const { visibleHeaders, titleOverride, newButtonComponent } = useSaveView({
    domain,
    userId: userDetails?.id,
    subModuleId,
    storageKey: "shift_roster_saved_views",
    fullHeaders: ShiftAssignmentHeader,
    screenAccess: check_access,
    onViewChange: handleSavedViewChange,
  });

  return handleLoader && (loading || hanldeLoading) ? (
    <Loader />
  ) : (
    <React.Fragment>
      <React.Fragment>
        {!showFullPage ? (
          <Box>
            <Box sx={{ mb: 2 }}>
              <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
                Rotation Patterns
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Schedule and assign employees to shifts
              </Typography>
            </Box>
            <Paper sx={{ width: "100%", height: "78vh" }}>
              <CustomFilter
                title="Rotation Pattern Records"
                titleOverride={titleOverride}
                filterHeaders={visibleHeaders}
                data={shiftAssignData}
                filteredData={shiftRotaData}
                searchKeys={keys}
                onFilteredDataChange={handleFilteredDataChange}
                screenAccess={check_access}
                downloadFormats={["excel", "pdf", "csv"]}
                includeMetadata={true}
                metadata={reportMetadata}
                newButtonComponent={
                  <>
                    {newButtonComponent}
                    <CustomButton
                      actionFuntion={() => {
                        if (check_access) {
                          setFormData({
                            config: {},
                            schedule: {},
                            preview: {},
                          });
                          setActiveStep(0);
                          setNumberOfSft(false);
                          handleCreateShiftRota();
                        } else {
                          showToast(
                            "error",
                            `Access denied: You are not authorized to create shift rota`,
                          );
                        }
                      }}
                      actionName="New"
                      typeName="button"
                    />
                  </>
                }
              />
              <Mui.Grid sx={{ ml: 2, mr: 2 }}>
                <Mui.TableContainer ref={containerRef} sx={{ maxHeight: 590 }}>
                  <Mui.Table className="border">
                    <Mui.TableHead
                      sx={{
                        backgroundColor: themes.primary,
                        position: "sticky",
                        top: -1,
                        zIndex: 10,
                      }}
                    >
                      <Mui.TableRow sx={tableRowSize}>
                        {visibleHeaders?.map((value) => (
                          <Mui.TableCell
                            sx={{
                              color: themes.headLine,
                              fontWeight: "bold",
                            }}
                          >
                            {value?.name}
                          </Mui.TableCell>
                        ))}
                      </Mui.TableRow>
                    </Mui.TableHead>
                    <Mui.TableBody>
                      {shiftRotaData?.length === 0 ? (
                        <TableEmptyState dataLength={shiftAssignData} />
                      ) : (
                        shiftRotaData
                          ?.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage,
                          )
                          ?.map((value) => (
                            <Mui.TableRow sx={tableRowSize}>
                              {visibleHeaders.map((head) => (
                                <Mui.TableCell
                                  onClick={() => {
                                    setEditSftRotaData([]);
                                    setRepresentationWeekdays([]);
                                    setRepresentationShifts([]);
                                    setShiftRotationDetails([]);
                                    handleViewShift();
                                    setSftAssignId(value?.id);
                                    setGetShiftRotaData(true);
                                  }}
                                >
                                  {head.key === "auto_shift_assign"
                                    ? value[head.key]
                                      ? "Yes"
                                      : "No"
                                    : value[head.key] || "N/A"}
                                </Mui.TableCell>
                              ))}
                            </Mui.TableRow>
                          ))
                      )}
                    </Mui.TableBody>
                  </Mui.Table>
                </Mui.TableContainer>
                <Box sx={{ mt: 1 }}>
                  {shiftRotaData?.length > 25 && (
                    <Mui.TablePagination
                      className="custom-pagination"
                      component="div"
                      rowsPerPageOptions={[25, 50, 75, 100]}
                      count={shiftRotaData?.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  )}
                </Box>
              </Mui.Grid>
            </Paper>
          </Box>
        ) : null}

        <Drawer
          anchor="right"
          open={opendSidebar}
          onClose={(event, reason) => {
            if (reason === "backdropClick" || reason === "escapeKeyDown") {
              return;
            }
            isCreatePanelOpen
              ? handleCreateClosePanel()
              : handleViewClosePanel();
          }}
          sx={{
            "& .MuiDrawer-paper": {
              width: "680px",
              maxWidth: "90vw",
              backgroundColor: themes?.whiteColor,
            },
          }}
        >
          {renderComponent()}
        </Drawer>
        {showFullPage ? (
          <Box
            sx={{
              backgroundColor: themes?.whiteColor,
            }}
          >
            {renderComponent()}
          </Box>
        ) : null}
      </React.Fragment>
    </React.Fragment>
  );
};
